<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '45vw' }" header="Department Details" :modal="true" class="p-fluid dialog-header" @hide="emit('hide-dialog', true)">
            <ol>
                <li v-for="department in allDepartments" :key="department">
                    <DepartmentBreadcrumb :deptId="department.id" />
                </li>
            </ol>
        </Dialog>
    </div>
</template>

<script setup>
import DepartmentBreadcrumb from './DepartmentBreadcrumb.vue';
import { ref, defineProps, defineEmits, computed } from 'vue';

const emit = defineEmits(['hide-dialog']);
const props = defineProps({
    departments: {
        type: Array,
    },
});

const visible = ref(true);

const allDepartments = computed(() => {
    return props.departments;
});
</script>
